import { gql } from 'apollo-angular';

export const BUSINESS_DETAIL_QUERY = gql`
  query getBusinessById($businessId: String!, $merchantId: String!) {
    GetBusinessById(businessId: $businessId, merchantId: $merchantId) {
      id
      name
      merchantId
      isEnabled
      address {
        line1
        line2
        state
        city
        country
        zip
        timeZone
        coordinates {
          latitude
          longitude
        }
      }
      vertical
      digitalAddresses {
        address
        preferred
        addressType
      }
      businessAttributes {
        deliveryCenters {
          zip
          line1
          line2
          state
          city
          country
          timeZone
          currency {
            currencyName
            currencyCode
          }
          coordinates {
            latitude
            longitude
          }
        }
        taxes {
          name
          rate
        }
        theme
        catalogues
        servicePlatforms {
          type
          businessTimings
          slots
          isEnabled
          platformFees
          liveCatalogueId
          avgServiceTimeInMin
          resources {
            id
            name
            attributes
            isEnabled
            serviceCapacity
            serviceTimeInMin
          }
          parcelBox {
            width
            weight
            unitCapacity
            length
            isAvailable
            height
          }
        }
      }
    }
  }
`;

export const GET_URLS_IMAGE_SLIDER = gql`
  query GetUrlsImageSliders($id: String!) {
    GetUrlsImageSliders(id: $id)
  }
`;
